import Avatar from "@amzn/awsui-chat-components-console/avatar";
import ChatBubble from "@amzn/awsui-chat-components-console/chat-bubble";
import Box from "@amzn/awsui-components-console/box";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';

const LoadingMessage = ({ id }: { id: string }) => (
    <ChatBubble
        key={id}
        ariaLabel={getString('chatbot.ariaLabels.generatingResponse')}
        showLoadingBar
        type="incoming"
        avatar={
            <Avatar
                loading={true}
                color="gen-ai"
                iconName="gen-ai"
                ariaLabel={getString('chatbot.ariaLabels.loadingAvatar')}
                tooltipText={getString('chatbot.ariaLabels.loadingAvatar')}
            />
        }
    >
        <Box color="text-status-inactive">{getString('chatbot.messages.generatingResponse')}</Box>
    </ChatBubble>
);

export default LoadingMessage;
